module.exports = __webpack_public_path__ + "static/devoxxpl-f7f2bcfd0245200275fd0db3625c09bd.png";